module.exports = __webpack_public_path__ + "img/mic_open.3a1ebca9.svg";